/**
 * defa.views.RecipientDeleteForm
 * A card for deleting Recipients
 * @version 1.0.0
 */
import Form     from '../../poppet/form';
import template from '../notifications/template-recipientGroup-delete-form.jst.html';

const RecipientGroupDeleteForm = Form.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template: template,
	
	templateContext: function () {
		return {
			recipientName: this.model.get('name')
		};
	},
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Attempts to save the information to the Model.
	 * @void
	 */
	submit: function () {
		// this.trigger('delete:recipientgroup');
		this.model.destroy();
		this.animateOut();
	},
	
} );

export default RecipientGroupDeleteForm;